import { type FeedbackTrigger } from '../../services/feedback/types';
import { useActiveAction } from '../active-action';
import { getActionSeededConversationOptions } from '../active-action/getActionSeededConversationOptions';
import { TAGS } from '../chat-store/types';
import { useConversation } from '../conversation/useConversation';

/**
 * Derives the `feedbackTrigger` value for the current conversation context.
 *
 * Checks two sources so the trigger is set both before and after the seeded
 * conversation is created:
 *
 * 1. `conversation.tags` — populated after the user sends a follow-up and the
 *    seeded conversation is persisted.
 * 2. The active action's `seededConversation.tags` — available immediately
 *    when the user views the initial insight message (before conversation
 *    creation).
 *
 * Extracted from `store-assistant` and `store-error` to prevent the two
 * components from drifting when new trigger conditions are added.
 */
export const useFeedbackTrigger = (): FeedbackTrigger | undefined => {
	const { conversation } = useConversation();
	const { activeAction } = useActiveAction();

	if (
		conversation?.tags?.includes(TAGS.INSIGHTS) ||
		getActionSeededConversationOptions(activeAction)?.tags?.includes(TAGS.INSIGHTS)
	) {
		return 'rovoInsights';
	}

	return undefined;
};
